import React from 'react';
import moment from 'moment';
import getOffsetTime from '../../../../utils/getOffsetTime';

const _ = require('lodash');

const generateItemDetails = async (item, state, scheduleType) => {
let idx;
let resource;
const { optimisticReRender, optimisticLiveSchedule, liveSchedule, postedSchedule } = state;
if (scheduleType === 'liveSchedule') {
  idx = liveSchedule.liveSchedule.findIndex((elem) => {
    return elem.rId === item.group;
  });
  resource = liveSchedule.liveSchedule[idx];
} else if (scheduleType === 'postedSchedule') {
  idx = await postedSchedule.postedSchedule.findIndex((elem) => {
    return elem.rId === item.group;
  });
  resource = postedSchedule.postedSchedule[idx];
}


let itemDetails;
if (item.itemType === 'assignment') {
  const startTime = moment.utc(item.modalStartTime, 'MM-DD-YYYY h:mma').format('h:mm a, MMM Do');
  const endTime = moment.utc(item.modalEndTime, 'MM-DD-YYYY h:mma').format('h:mm a, MMM Do');
  let blankAssignment;
  if (startTime === endTime) {
    blankAssignment = true;
  }
  let assignment; // the assignment that gets read
  if (item.backgroundColor === "#ffcc66" || item.backgroundColor === "#c3e2fa" || item.backgroundColor === "gray") { // if assignment has a gold background color it must be on-call / stand by
    assignment = resource.dayTypes[item.rdtId].assignment;
    if(!assignment){
      assignment = resource.dayTypes[item.rdtId].tour.assignments[item.id];
    }
  } else assignment = resource.dayTypes[item.rdtId].tour.assignments[item.id];
  const { service, costObject, costObjectNumber, comment,
      activityType, description, requestNumber, myAssignmentComment, costOnFacility, isApproved, altResource, altType, assignmentContract,overtimeReason } = assignment;
  itemDetails = {
    itemType: item.itemType,
    title: 'Assignment Details',
    comment,
    startTime: !blankAssignment ? startTime : '',
    endTime: !blankAssignment ? endTime : '',
    service,
    costObject,
    costObjectNumber,
    requestNumber,
    activityType,
    description,
    myAssignmentComment,
    resourceClass: item.resourceClass,
    costOnFacility,
    isApproved,
    altResource,
    altType,
    assignmentContract,
    overtimeReason
  };
} else if (item.itemType === 'off-request') {
  // Getting the real id of an object that goes across multiple objects that has a temp id so that it can be displayed.
  let tempId;
  if (typeof(item.id) === 'string' && item.id.includes('-')) {
    tempId = item.id.split('-')[0];
  } else tempId = item.id;

  const date = moment(item.start_time).format('M/D/YYYY');
  const { dayTypeName } = resource.dayTypes[tempId];
  const { dayOffRequestTitle, dayTypeComment, myDayTypeComment } = resource.dayTypes[tempId].dayOffRequest;
  itemDetails = {
    itemType: item.itemType,
    title: 'Day Type Request Details',
    dayOffRequestTitle,
    dayTypeName,
    dayType: "Day Off Request",
    date,
    dayTypeComment,
    myDayTypeComment
  };
} else if (item.itemType === 'off-time') {
  console.log(resource.dayTypes[item.id].dayOff)
  const date = moment(item.start_time).format('M/D/YYYY');
  const { dayTypeName } = resource.dayTypes[item.id];
  const { abbreviation, dayTypeComment, myDayTypeComment, isApproved,wbse,showCostObjectId,costCenter  } = resource.dayTypes[item.id].dayOff;
  itemDetails = {
    itemType: item.itemType,
    title: 'Day Type Details',
    abbreviation,
    dayTypeName,
    date,
    dayTypeComment,
    myDayTypeComment,
    isApproved,
    wbse,
    showCostObjectId,
    costCenter 
  };
} else if (
  item.itemType === 'tour'
  || item.itemType === 'overtime'
  || item.itemType === 'meal'
  || item.itemType === 'pay-transaction'
  || item.itemType === 'indicators'
) {
  const { startTime, duration, meal, overtime, notificationComment,
    tourComment, myTourComment, tourIndicators, tourPayTransactions, isApproved,tourContract, costCenter, wbse } = resource.dayTypes[item.rdtId].tour;

  // liveSchedule || postedSchedule
  const remoteIndicator = resource.dayTypes[item.rdtId].remoteIndicator || resource.dayTypes[item.rdtId].tour.remoteIndicator;

  let tourPayTransactionsArray = [];
  if (tourPayTransactions) {
    tourPayTransactions.forEach(payTransactions => {
      if (scheduleType === 'postedSchedule') {
        tourPayTransactionsArray.push(' ' + payTransactions);
      }
      else if (scheduleType === 'liveSchedule') {
        tourPayTransactionsArray.push(' ' + payTransactions.code);
      }
    });
  }

 // Indicators
 let tourIndicatorsArray = [];
 let tourIndicatorsWithRemote = tourIndicators ? _.cloneDeep(tourIndicators) : [];
  // insert remote indicator at the front of indicator array if it exists
  if (remoteIndicator) {
    tourIndicatorsWithRemote.unshift({
      name: "Remote Location"
    });
  }

  tourIndicatorsArray = tourIndicatorsWithRemote.map((indicator, idx) => {
    if ((remoteIndicator && idx === 0)
      || (indicator.name === indicator.code)
    ) {
      return ` ${indicator.name}`;
    } else {
      return ` ${indicator.name} / ${indicator.code}`;
    }
  })


  const initialTourTime = moment.unix(startTime);
  const timeOffset = getOffsetTime(initialTourTime._d);
  const dayTypeTitle = resource.dayTypes[item.rdtId].title;

  // *** NOTE *** these tour start/end times are based upon initial liveSchedule array from the parser, not that returned from 'generateTour' function

  const tourStartTime = moment.utc(initialTourTime).format('h:mm a, MMM Do');
  const tourEndTime = moment.utc(tourStartTime, 'h:mm a, MMM Do').add(+duration, 'hours').format('h:mm a, MMM Do');

  // *** NOTE *** meals are not independent items in the live schedule array like i.e. assignments, they are always embedded inside a tour, thus the 'meal' being referenced
  // here (pulled from the resource.dayTypes[item.rdtId].tour object above) is in original form coming from parser, not that returned from 'generateMeal' function

  const mealStartTime = resource.dayTypes[item.rdtId].tour.meal ? moment(moment.utc(moment.unix(meal.mealTime))).format('h:mm a,  MMM Do') : 'N/A';
  const mealEndTime = resource.dayTypes[item.rdtId].tour.meal ? moment(moment.utc(moment.unix(meal.mealEndTime))).format('h:mm a, MMM Do') : 'N/A';
  const overtimeStartTime = resource.dayTypes[item.rdtId].tour.overtime ? moment(moment.unix(overtime.startTime)).format('h:mm a,  MMM Do') : 'N/A';
  const overtimeEndTime = resource.dayTypes[item.rdtId].tour.overtime ? moment(moment.unix(overtime.endTime)).format('h:mm a, MMM Do') : 'N/A';

  itemDetails = {
    itemType: item.itemType,
    title: 'Tour Details',
    dayTypeTitle,
    tourStartTime,
    tourEndTime,
    mealStartTime,
    mealEndTime,
    overtimeStartTime,
    overtimeEndTime,
    tourIndicators: tourIndicatorsArray ? tourIndicatorsArray.toString() : null,
    tourPayTransactions: tourPayTransactionsArray && scheduleType === 'liveSchedule' ? tourPayTransactionsArray.toString() : tourPayTransactions && scheduleType === 'postedSchedule' ? tourPayTransactions.toString() : null,
    notificationComment,
    tourComment,
    myTourComment,
    isApproved,
    tourContract,
    costCenter,
    wbse
  };
}
  return itemDetails;
}

export default generateItemDetails;



// WEBPACK FOOTER //
// ./src/Components/Schedule/SevenNineDay/utils/generateItemDetails.js